import './style/index';

import _Skeleton from './skeleton';

export type { SkeletonProps } from './skeleton';
export * from './type';

export const Skeleton = _Skeleton;
export default Skeleton;
